import { customUrlBuilderColyseus } from "@durak/common"
import { Client } from "colyseus.js"

const customUrlBuilder = (url: URL): string => {
  return customUrlBuilderColyseus(url, import.meta.env.VITE_WEB_SOCKETS)
}

export const colyseusClient = new Client(import.meta.env.VITE_WEB_SOCKETS, {
  urlBuilder: customUrlBuilder,
})
